const translations = {
    createProductUsageReport: 'Create Product Usage Report',
    downloadInvoicePdf: 'Download Job Estimate',
    downloadWorkOrderPdf: 'Download Work Order PDF'
};

export default translations;
